import axios from 'axios'
import Vue from 'vue'

export const FOLDER_ID = 'b1g1n4p7k7ar02bjo4br';

const API = 'https://l.fitness365.ru/Assistant'; //https://l.fitness365.ru/Assistant   // http://fit365bot.dot-m.ru/Assistant

export const yandexApi = axios.create({
  baseURL: `${API}`,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Api-Key 123`,
  },
});

yandexApi.interceptors.response.use(
  response => response,
  error => {
    console.log(error);
    let message = 'Ошибка запроса';
    if (error.response && error.response.data) {
      if (error.response.status == 429) {
        message = 'Ой, слишком много запросов. Попробуйте попозже.';
      } else if (error.response.data.message) {
        message = error.response.data.message;
      } else {
        message = error.response.data;
      }
    } else if (error.message) {
      message = error.message;
    }

    Vue.toasted.show(message, {
      type: 'error',
      duration: 5000
    });

    return Promise.reject(error);
  }
);

/**
 * Стрим через axios/XHR.
 * onEvent(obj) — вызывается на каждый JSON-чанк (одна строка)
 * onError(err) — ошибка запроса (не отмена)
 * onDone() — завершение (в т.ч. при закрытии потока)
 *
 * Возвращает { cancel() } — для отмены.
 */
export function postMessageStream(runBody, onEvent, onError, onDone) {
  const controller = new AbortController();
  const abortSignal = controller.signal;

  let buf = '';
  let lastLength = 0;

  const cfg = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Api-Key 123`
    },
    onDownloadProgress: (progressEvent) => {
      const xhr = progressEvent.currentTarget || progressEvent.target;
      const text = xhr.responseText;

      // берём только новый кусок
      const chunk = text.substring(lastLength);
      lastLength = text.length;
      if (!chunk) return;

      buf += chunk;

      // режем по \n — один JSON-объект на строку
      let idx;
      while ((idx = buf.indexOf('\n')) >= 0) {
        const line = buf.slice(0, idx).trim();
        buf = buf.slice(idx + 1);

        if (!line) continue;
        try {
          const obj = JSON.parse(line);
          onEvent && onEvent(obj);
          //console.log('chunk:', line);
        } catch (ex) {
          console.error('Broken JSON line:', line);
        }
      }
    },
    signal: abortSignal,
  };

  yandexApi.post(API + '/messageStream', runBody, cfg)
    .then(() => {
      // дочитаем остаток, если сервер не закрыл строку \n
      const rest = buf.trim();
      if (rest) {
        try {
          onEvent && onEvent(JSON.parse(rest));
        } catch (ex) {}
      }
      onDone && onDone();
    })
    .catch((err) => {
      const canceled = err.name === 'CanceledError' || err.code === 'ERR_CANCELED';
      if (!canceled) onError && onError(err);
    });

  return { cancel: () => controller.abort() };
}


// WEBPACK FOOTER //
// ./src/components/api/yandex-api.js